export default () => {

    if(location.hash) {
        setTimeout(() => { 
            let element = document.getElementById(location.hash.substring(1));
            element.scrollIntoView();
        }, 2000)
    }


}